import React from 'react'
import { useSelector } from 'react-redux'
import { IStore } from '../../interfaces/Store'
import { STATUS } from '../../enums/common'
import Spinner from '../Spinner'
import AddressNotChangeHostDocumentUpload from './AddressNotChangeHostDocumentUpload'
import { ILogementProps } from '../../interfaces/Logement'

const AddressNotChangeHostDocument = (props: ILogementProps) => {
  const personStatus = useSelector(
    (store: IStore) => store.personReducer.status
  )
  if (personStatus !== STATUS.loaded) {
    return (
      <div className="col12 mt1 dFlex alignItemsCenter justifyContentStart">
        <div className="relative pb3 pl3">
          <Spinner small={true} />
        </div>
      </div>
    )
  }

  return <AddressNotChangeHostDocumentUpload {...props} />
}

export default AddressNotChangeHostDocument
